import { render, staticRenderFns } from "./RedeemBalance.vue?vue&type=template&id=a638f2ea&scoped=true"
import script from "./RedeemBalance.vue?vue&type=script&lang=js"
export * from "./RedeemBalance.vue?vue&type=script&lang=js"
import style0 from "./RedeemBalance.vue?vue&type=style&index=0&id=a638f2ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a638f2ea",
  null
  
)

export default component.exports